export default function initDropdowns(): void {
    const $dropdownsContainer = document.querySelectorAll<HTMLElement>('.js-dropdowns');

    $dropdownsContainer.forEach($container => {
        new Dropdowns($container);
    });
}

class Dropdowns {
    $el: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (this.$el) {
            this.dropdownHandler();
        }
    }



    dropdownHandler(): void {
        const dropdowns = this.$el?.querySelectorAll<HTMLDetailsElement>('.dropdown');

        // Skip if no dropdowns found
        if (!dropdowns || dropdowns.length === 0) return;

        // First, set up click handlers for each dropdown
        dropdowns.forEach((dropdown) => {
            dropdown.addEventListener('click', (event) => {
                event.preventDefault();

                dropdowns.forEach((item) => {
                    if (item !== dropdown) {
                        item.open = false;
                    }
                });

                dropdown.open = !dropdown.open;
            });
        });

        if (dropdowns[0]) {
            dropdowns[0].open = true;
        }
    }
}
